import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_JOB_BY_ID = gql`
  query GetJobById($id: ID!) {
    jobMarket(id: $id) {
      id
      name
      description
      positionType
      numberOfPositions
      details
      requirements
      salary
      state
      applyType
      viewType
      image {
        ...imageFields
      }
      customMedia {
        image {
          ...imageFields
        }
        document {
          id
          name
          filePath
        }
      }
      jobs {
        id
        bicID
        name
        interestFields {
          id
        }
      }
      additionalInfo {
        from
        to
        workFrom
        workTo
        age
      }
      startDate
      startType
      applyUntil
      openDate
      closeDate
      contact {
        id
        employeePosition
        picture {
          ...imageFields
        }
        communication {
          id
          entries {
            id
            entryValue
            communicationType {
              name
              shortName
            }
          }
        }
        person {
          id
          firstname
          lastname
          sex
          titles {
            id
            shortName
            description
          }
        }
      }
      companyProfile {
        name
        uuid
        id
        companyBenefits {
          id
          name
        }
        mediaGallery {
          ...mediaGalleryFields
        }
        companyProfilePicture {
          ...imageFields
        }
      }
      addresses {
        id
        number
        street
        addressLatLon {
          lat
          lon
        }
        addressCity {
          name
          addressDistrict {
            name
          }
        }
      }
      onlineUrl
    }
  }
  ${ImageFragment}
  ${MediaGalleryFragment}
`;
